import { LoadableAfterPaint } from '@confluence/loadable';

export const InlineImage = LoadableAfterPaint({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-InlineImage" */ './InlineImage.tsx')).InlineImage,
});
